/*
 * appuntamenti.js
 * ---------------
 * Exports the appuntamenti page component.
 */

/* eslint-disable react/no-unescaped-entities */
/* eslint-disable react/jsx-one-expression-per-line */

import React, { useEffect, useState } from "react";

import Button from "../components/button";
import { Select } from "../components/select";
import SiteMetadata from "../components/site-metadata";
import TextPageLayout from "../components/text-page-layout";
import { defaultLang } from "../constants";
import { useIntl } from "../hooks/useIntl";
import markdownPagePaths from "../markdownPagePaths.json";
import styles from "../styles/appuntamenti.module.scss";

const metadata = {
  title: "Prenota un appuntamento gratuito con un consulente dedicato",
  description:
    "Prenota un appuntamento gratuito con un nostro consulente dedicato.",
};

const showroomSelectOptions = [
  {
    label: "Corso XXVII Marzo, 58, Voghera, PV",
    value: "corso-27-marzo-voghera",
  },
  {
    label: "Via Nazionale, 29, Stradella, PV",
    value: "via-nazionale-29-stradella",
  },
  {
    label: "Via Eraldo Fico, 82, Sestri Levante, GE",
    value: "via-eraldo-fico-82-sestri-levante",
  },
];

const meetingModeSelectOptions = [
  {
    label: "In negozio",
    value: "in-showroom",
  },
  {
    label: "A casa tua",
    value: "at-custom-address",
  },
  {
    label: "Videochiamata",
    value: "videocall",
  },
];

const googleCalendarLinkByShowroomAndMeetingMode = {
  "corso-27-marzo-voghera": {
    "at-custom-address": "https://calendar.app.google/XZAZWAH8KkPkjYL36",
    "in-showroom": "https://calendar.app.google/Y6eBrACajV3UVG5M8",
    videocall: "https://calendar.app.google/YyCu2ugXYtddyyAc7",
  },
  "via-nazionale-29-stradella": {
    "at-custom-address": "https://calendar.app.google/X9S6N9SP1xsrP3w39",
    "in-showroom": "https://calendar.app.google/pqQv6r3tPhK6TbE27",
    videocall: "https://calendar.app.google/KB4sgJXdoFMgJZ1H8",
  },
  "via-eraldo-fico-82-sestri-levante": {
    "at-custom-address": "https://calendar.app.google/uJgBAbrcrjwHSspYA",
    "in-showroom": "https://calendar.app.google/Qbk75RJfjW4pxvrK8",
    videocall: "https://calendar.app.google/ruBB49W8jxsGUZcY9",
  },
};

function getShowroomQueryParam() {
  const urlParams = new URLSearchParams(window.location.search);

  const showroomQueryParam = urlParams.get("showroom");

  if (
    showroomSelectOptions.some((option) => option.value === showroomQueryParam)
  ) {
    return showroomQueryParam;
  }

  return "";
}

const AppuntamentiPage = ({ location }) => {
  const { lang, setLang, setPageLangVariants } = useIntl();

  const [selectedShowroom, setSelectedShowroom] = useState("");

  const [meetingMode, setMeetingMode] = useState("");

  const handleShowroomChange = (event) => {
    setSelectedShowroom(event.target.value);
  };

  const handleMeetingModeChange = (event) => {
    setMeetingMode(event.target.value);
  };

  useEffect(() => {
    setLang(defaultLang);
    setPageLangVariants(null);
  }, [setLang, setPageLangVariants]);

  useEffect(() => {
    const showroomQueryParam = getShowroomQueryParam();

    if (!showroomQueryParam) {
      return;
    }

    setSelectedShowroom(showroomQueryParam);
  }, []);

  return (
    <TextPageLayout>
      <SiteMetadata location={location} {...metadata} />

      <h1>{metadata.title}</h1>

      <p>
        Scegli il negozio che preferisci e la modalità d'incontro più comoda per
        te: potrai incontrare il nostro consulente di persona in negozio,
        direttamente a casa tua o tramite videochiamata, dove e quando ti è più
        comodo.
      </p>

      <p>
        Ti guideremo passo dopo passo per offrirti un'esperienza su misura,
        pensata per le tue esigenze.
      </p>

      <div className={styles.formElementsContainer}>
        <Select
          label="Negozio"
          name="showroom"
          onChange={handleShowroomChange}
          options={showroomSelectOptions}
          placeholder="-- Seleziona un Negozio --"
          value={selectedShowroom}
        />

        {!!selectedShowroom && (
          <Select
            label="Modalità d'incontro"
            name="meeting-mode"
            onChange={handleMeetingModeChange}
            options={meetingModeSelectOptions}
            placeholder="-- Seleziona una modalità d'incontro --"
            value={meetingMode}
          />
        )}

        {!!selectedShowroom && !!meetingMode && (
          <div>
            <Button
              className={styles.formButton}
              to={
                googleCalendarLinkByShowroomAndMeetingMode[selectedShowroom][
                  meetingMode
                ]
              }
              type="contained"
              color="secondary"
              size="large"
            >
              Scegli data e ora
            </Button>

            <p className={`${styles.privacyStatement} ${styles.textJustify}`}>
              Il trattamento dei dati personali condivisi durante la
              prenotazione dell'appuntamento sarà effettuato in conformità con
              la nostra{" "}
              <a
                href={markdownPagePaths.privacy[lang]}
                rel="noopener noreferrer"
                target="_blank"
              >
                Privacy Policy
              </a>
              . Ti invitiamo a consultarla per maggiori dettagli.
            </p>
          </div>
        )}
      </div>
    </TextPageLayout>
  );
};

export default AppuntamentiPage;
